import React from 'react';
import { Mail, MapPin, Phone, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-5 gap-8 mb-12 items-start">
          {/* About */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 rounded-full overflow-hidden flex items-center justify-center flex-shrink-0">
                <img 
                  src="https://customer-assets.emergentagent.com/job_7d6b48dd-3a56-4bdf-ab4a-3099abb2356a/artifacts/tl7d7og3_TCCC_logo_jpg.jpg" 
                  alt="TC Cheyres-Châbles Logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="font-bold text-lg">TC Cheyres-Châbles</div>
                <div className="text-sm text-gray-400">Tennis & Padel</div>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              Depuis plus de 40 ans, notre club de tennis offre des installations de qualité 
              et une ambiance conviviale pour tous les passionnés de tennis et de padel.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/share/1GKycXjVzq/" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/tennischeyreschables?igsh=MjlzNWRmNTljZWJ4" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div className="md:col-span-2 text-center">
            <h3 className="font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 justify-center">
                <MapPin className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" />
                <span className="text-gray-400 text-sm">
                  Route de Crevel 301<br />
                  1468 Cheyres<br />
                  Suisse
                </span>
              </li>
              <li className="flex items-start space-x-3 justify-center">
                <Mail className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" />
                <a href="mailto:tccheyres@gmail.com" className="text-gray-400 hover:text-white transition-colors text-sm">
                  tccheyres@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Coordonnées bancaires */}
          <div className="md:col-span-1 text-center md:text-right">
            <h3 className="font-bold text-lg mb-4">Coordonnées bancaires</h3>
            <div className="text-gray-400 text-sm space-y-2">
              <p>CCP: 17-49-3</p>
              <p className="whitespace-nowrap">IBAN: CH30 0076 8250 1107 4680 2</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} TC Cheyres-Châbles. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;